import Flickity from 'flickity';

class wwdevFlickity extends Flickity {
	activate() {
		super.activate();
		this.element.classList.add('flickity-loaded');
	}

	resize() {
		this.element.classList.remove('flickity-loaded');
		super.resize();
		this.element.classList.add('flickity-loaded');
	}
}

export default wwdevFlickity;